import { call, put } from 'redux-saga/effects';
import { ActionType } from 'deox';

import { checkAccessToken } from '@/utils/handle-authentication';
import { updateLicenseEmployeeAction } from '@/redux/actions/employee';
import { updateLicenseEmployee, TUpdateLicenseEmployeeResponse } from '@/services/api/employee';
import { handleAPIError } from '@/utils/handle-api-error';

// FUNCTION
export function* updateLicenseEmployeeSaga(action: ActionType<typeof updateLicenseEmployeeAction.request>): Generator {
  const { materials, companyId, employeeId, successCallback, failedCallback } = action.payload;
  try {
    yield call(checkAccessToken);
    const response = yield call(updateLicenseEmployee, materials, companyId, employeeId);
    const updateLicenseEmployeeResponse: TUpdateLicenseEmployeeResponse = response as TUpdateLicenseEmployeeResponse;
    yield put(updateLicenseEmployeeAction.success(updateLicenseEmployeeResponse));
    successCallback?.(updateLicenseEmployeeResponse);
  } catch (err) {
    yield put(updateLicenseEmployeeAction.failure(err));
    failedCallback?.(err);
    handleAPIError(err, 'Error.editEmployeeInfoError');
  }
}
